var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobDescHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 465,
    viewBox: "0 0 1440 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1361.34 542.083L1877.1 288.054L1877.1 598.091L1361.56 850.323L1361.34 542.083Z",
    stroke: "#CCCCF5",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.31 69.2221L1938.34 -210.919L2060.81 40.183L1369.56 377.328L1369.31 69.2221Z",
    stroke: "#CCCCF5",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.34 272.083L1727.1 18.0538L1727.1 368.091L1211.57 620.323L1211.34 272.083Z",
    stroke: "#CCCCF5",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M942.341 639.083L1458.1 385.054L1458.1 695.091L942.565 947.323L942.341 639.083Z",
    stroke: "#CCCCF5",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-443.659 171.244L72.1025 -82.7855L72.1025 267.252L-443.435 519.484L-443.659 171.244Z",
    stroke: "#CCCCF5",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-515.692 74.3827L53.3431 -205.758L175.814 45.3436L-515.436 382.488L-515.692 74.3827Z",
    stroke: "#CCCCF5",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDescHeaderBg);
export default __webpack_public_path__ + "static/media/job-desc-header-bg.312630c9de9d2b08920deb23c4bcee58.svg";
export { ForwardRef as ReactComponent };